import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=a5c184e6&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=a5c184e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c184e6",
  null
  
)

export default component.exports